import { AxiosError } from 'axios'
import { TFunction } from 'next-i18next'
import { formatResponseError, isNotIssued } from '@fe/common/utils/axiosUtils'

/**
 * The text to show when the requisites (deposit details, crypto addresses)
 * were refused. An HTTP error with a JSend `error` body shows its message as
 * it is: formatResponseError would put it in JSON quotes.
 */
export const requisitesErrorText = (error: unknown, t: TFunction): string => {
  if (isNotIssued(error)) {
    return t('transactions:requisites-not-issued')
  }

  const body = (error as AxiosError)?.response?.data as
    | { status?: unknown; message?: unknown }
    | undefined

  if (
    body?.status === 'error' &&
    typeof body.message === 'string' &&
    body.message
  ) {
    return body.message
  }

  return formatResponseError(error as AxiosError, t)
}
